const translation = {
  Product: "Продукт",
  "Header.productNav": "Продукт LUKKEY",
  Feature: "Особенности",
  "About Us": "О нас",
  FAQ: "Часто задаваемые вопросы",
  "Privacy Policy": "Политика конфиденциальности",
  "Help Center": "Центр помощи",
  "Header.infoMenu": "Ещё",
  "Header.appNow": "Скачать приложение",
  "Header.appModal.title": "Используйте приложение LUKKEY сейчас",
  "Header.appModal.subtitle": "Выберите платформу, чтобы получить официальное мобильное приложение LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Установите официальное приложение на iPhone.",
  "Header.appModal.iosButton": "Открыть",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Получите официальное Android-приложение в Google Play.",
  "Header.appModal.googlePlayButton": "Открыть",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Скачайте последнюю официальную APK напрямую.",
  "Header.appModal.androidButton": "Скачать",
  "Header.appModal.note": "Только официальные мобильные загрузки. Используйте ссылки выше для последней версии.",
  "Academy": "Академия",
  "Legal": "Юридическая информация",
  "AboutUs.title": "О LUKKEY",
  "AboutUs.lede": "LUKKEY — швейцарский бренд аппаратных кошельков, предназначенный для создания наивысшего стандарта безопасности владения цифровыми активами.",
  "AboutUs.vision.closing": "Ваши ключи. Ваши активы. Ваше будущее.",
  "AboutUs.quote": "LUKKEY создает уровень безопасности между людьми и цифровыми активами.",
  "AboutUs.block1": "LUKKEY базируется в Швейцарии. Компания сосредоточена на аппаратных кошельках для безопасного самостоятельного хранения активов.",
  "AboutUs.block2": "Продукты сочетают secure element, защиту от вскрытия и полностью офлайн-архитектуру. Цель состоит в том, чтобы приватные ключи оставались в изолированной среде.",
  "AboutUs.block3": "Система разработана без Wi‑Fi, USB и прямой сетевой зависимости. Доступ по отпечатку пальца, NFC-инструменты резервного копирования и широкая поддержка активов делают ее практичной в повседневном использовании.",
  "AboutUs.block5": "LUKKEY придерживается открытого и аудируемого подхода к основной прошивке и программному обеспечению. Заявления о безопасности должны оставаться проверяемыми и подтверждаемыми.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Запрос в поддержку",
  "WarrantySupport.intro": "Пожалуйста, заполните информацию ниже, чтобы отправить запрос в поддержку.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Краткое описание",
  "WarrantySupport.form.issueTitle.placeholder": "Введите краткое описание",
  "WarrantySupport.form.warrantyType.label": "Тип запроса",
  "WarrantySupport.form.warrantyType.placeholder": "Выберите тип запроса",
  "WarrantySupport.form.warrantyType.product": "Проблема устройства",
  "WarrantySupport.form.warrantyType.service": "Проблема приложения/аккаунта",
  "WarrantySupport.form.warrantyType.replacement": "Другое",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Опишите проблему или запрос подробно",
  "WarrantySupport.form.submit": "Отправить запрос в поддержку",
  "WarrantySupport.alert.success": "Ваш запрос в поддержку отправлен!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Центр помощи",
  "HelpCenter.intro":
    "Добро пожаловать в Центр помощи LUKKEY! Если вы новичок в криптовалютах или вам нужна помощь с холодным кошельком, вы по адресу. Наше решение холодного кошелька обеспечивает самый безопасный способ хранения и управления цифровыми активами. Ниже вы найдете ответы на наиболее частые вопросы и советы по устранению неполадок.",
  "HelpCenter.section4.title": "Нужна дополнительная помощь?",
  "HelpCenter.section4.intro":
    "Сэкономьте время, начав запрос поддержки онлайн, и мы свяжем вас со специалистом. В целях безопасности официальный саппорт никогда не попросит вашу фразу восстановления или приватный ключ:",
  "HelpCenter.contact.hint": "Нажмите кнопку, чтобы отправить запрос поддержки, и мы свяжемся с вами по электронной почте.",
  "HelpCenter.cta.warranty": "Отправить запрос в поддержку",
  brandName: "LUKKEY",
  tagline: "Управляйте своими криптовалютами как никогда раньше",
  description:
    "Начните свое путешествие к финансовой свободе с нашим приложением. Защитите свои активы с помощью нашей передовой технологии холодного кошелька и управляйте своими финансами более умно и эффективно. Ваше финансовое благополучие — наш приоритет.",
  "home.seoTitle": "LUKKEY | Швейцарский аппаратный кошелек для безопасного self-custody",
  "home.seoDescription": "LUKKEY — швейцарский бренд аппаратных кошельков, ориентированный на безопасность cold wallet, офлайн-защиту приватных ключей, доступ по отпечатку пальца и NFC-резервное копирование для безопасного self-custody.",
  learnMore: "Узнать больше",
  "Lock Your Crypto, Securely": "Надежно заблокируйте свои криптовалюты",
  Testimonials: "Отзывы",
  Testimonial1:
    "Я использую этот холодный кошелек уже несколько месяцев, и я впечатлен его надежностью и функциями безопасности. Настоятельно рекомендую!",
  Testimonial2:
    "Этот холодный кошелек превзошел мои ожидания! Его удобный интерфейс и отличная безопасность делают его обязательным инструментом для всех, кто серьезно относится к криптовалютам.",
  Testimonial3:
    "Я пробовал несколько холодных кошельков раньше, но этот выделяется. Его стильный дизайн и передовые функции позволяют легко управлять моими криптоактивами.",
  "John Doe": "Джон Доу",
  "Cryptocurrency Enthusiast": "Энтузиаст криптовалют",
  "Jane Smith": "Джейн Смит",
  "Crypto Security Advocate": "Защитник безопасности криптовалют",
  "Alex Johnson": "Алекс Джонсон",
  "Investment Analyst": "Инвестиционный аналитик",
  "Touchscreen Interface": "Интерфейс с сенсорным экраном",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Используйте наш интуитивно понятный интерфейс с сенсорным экраном для удобного управления криптовалютой, позволяющий быстро и легко навигировать по вашим цифровым активам, обеспечивая быстрые транзакции и безопасное управление.",
  "Bluetooth Connectivity": "Подключение по Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Беспроводная синхронизация с вашими устройствами для обновлений в реальном времени.",
  "Airtag Tracking": "Отслеживание с помощью Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Легко отслеживайте свой кошелек с помощью встроенного Airtag.",
  "Secure Chip Technology": "Технология защищенного чипа",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Оснащен передовым чипом безопасности, обеспечивающим надежную защиту ваших ценных цифровых активов от несанкционированного доступа и киберугроз.",
  "Cross-Platform Support": "Поддержка нескольких платформ",
  "Works with various platforms for easy accessibility.":
    "Работает с различными платформами для легкости доступа.",
  AboutUsDescription1:
    "В LUKKEY мы занимаемся предоставлением высококачественных решений для безопасного управления вашими криптовалютными активами.",
  AboutUsDescription2:
    "Наш главный офис находится в Цуге, Швейцария. С командой опытных профессионалов мы стремимся к инновациям и адаптации к постоянно меняющемуся рынку цифровых валют.",
  BlockchainNetworksSupported: "Поддерживаемые блокчейн-сети",
  CryptocurrenciesSupported: "Поддержка более 6 000 криптовалют",
  Years: "Годы",
  ExpertiseInSecurity: "опыт в области безопасности",
  FrequentlyAskedQuestions: "Часто задаваемые вопросы",
  WhatIsColdWallet: "Что такое холодный кошелек?",
  ColdWalletDescription:
    "Холодный кошелек - это тип криптовалютного кошелька, который хранит ваши цифровые активы офлайн, что делает его менее уязвимым для взломов и других онлайн-угроз. В отличие от горячих кошельков, которые подключены к интернету и удобны для частых транзакций, холодные кошельки лучше всего подходят для долгосрочного хранения, так как они обеспечивают усиленную безопасность.",
  HowToSetUpColdWallet: "Как настроить холодный кошелек?",
  ColdWalletSetupDescription:
    "Настройка холодного кошелька обычно включает в себя инициализацию устройства на безопасной оффлайн-машине. Вам нужно будет создать и безопасно хранить фразу восстановления, которая необходима для доступа к вашим активам в случае потери устройства или его поломки. Подробные инструкции предоставляются с покупкой, чтобы гарантировать плавный процесс настройки.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Какие криптовалюты совместимы с вашими холодными кошельками?",
  CryptocurrenciesCompatibilityDescription:
    "Наши холодные кошельки поддерживают широкий спектр криптовалют, включая основные такие как Bitcoin, Ethereum и Litecoin, а также различные альткойны. Для получения полного списка поддерживаемых валют, пожалуйста, посетите наш сайт или обратитесь к документации продукта.",
  HowToSecureColdWallet:
    "Как обеспечить безопасность моего холодного кошелька?",
  ColdWalletSecurityDescription:
    "Чтобы обезопасить свой холодный кошелек, всегда храните фразу восстановления в безопасном и приватном месте, не делитесь ею с кем-либо и подумайте о дополнительных мерах безопасности, таких как биометрические блокировки или защищенные корпуса. Регулярное обновление прошивки кошелька с официального вебсайта также помогает защититься от уязвимостей.",
  ColdWalletNotWorking:
    "Что делать, если мой холодный кошелек не работает или я сталкиваюсь с ошибкой?",
  ColdWalletErrorDescription:
    "Если у вас возникли проблемы с холодным кошельком, обратитесь к разделу устранения неполадок в руководстве пользователя. Для более конкретных проблем свяжитесь с нашей службой поддержки через наш сайт. Убедитесь, что у вас под рукой есть информация о вашем устройстве, чтобы ускорить процесс поддержки.",
  Community: "Сообщество",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Присоединяйтесь к нашему сообществу на вашей любимой платформе, чтобы оставаться в курсе событий, задавать вопросы и общаться с другими пользователями.",
  "Subscribe.title": "Получать обновления продукта",
  "Subscribe.subtitle":
    "Мы отслеживаем криптотренды за вас. Получайте обновления продукта, рыночную аналитику и эксклюзивные привилегии — прямо на вашу почту.",
  "Subscribe.placeholder": "Введите ваш e-mail",
  "Subscribe.button": "Подписаться на обновления продукта",
  "Subscribe.input.aria": "Поле ввода адреса электронной почты",
  "Subscribe.success":
    "Спасибо за подписку! Проверьте почту и найдите письмо с подтверждением.",
  "Subscribe.error":
    "Не удалось оформить подписку. Пожалуйста, попробуйте позже.",
  "Subscribe.invalid":
    "Пожалуйста, введите корректный адрес электронной почты.",
  "Subscribe.privacy":
    "Ваш адрес электронной почты используется только для отправки нашей рассылки и обновлений. Вы можете отписаться в любое время по ссылке в письме.",
  "Subscribe.learnMore":
    "Узнайте больше о том, как мы обрабатываем ваши данные и о ваших правах.",
  "Subscribe.popupCompact.title": "Будьте в курсе",
  "Subscribe.popupCompact.subtitle":
    "Обновления продукта и советы по безопасности. Без спама.",
  "Subscribe.popupCompact.button": "Подписаться",
  "Subscribe.popupCompact.privacy":
    "Только e-mail. Отписаться можно в любое время.",
  "SubscribeConfirmed.alt.success": "Подписка подтверждена",
  "SubscribeConfirmed.alt.failed": "Подписка не выполнена",
  "SubscribeConfirmed.title.success": "Подписка подтверждена",
  "SubscribeConfirmed.title.failed": "Подписка не выполнена",
  "SubscribeConfirmed.message.success":
    "Спасибо за подтверждение вашей электронной почты. Ваша подписка активирована. Приветственное письмо отправлено на вашу почту.",
  "SubscribeConfirmed.message.failed":
    "Ссылка подтверждения недействительна или устарела. Пожалуйста, вернитесь на главную страницу и попробуйте подписаться снова.",
  "SubscribeConfirmed.cta.backHome": "На главную",
  "SubscribeConfirmed.note.unsubscribe":
    "Вы можете отписаться в любое время по ссылке в наших письмах.",
  // ===== MarketView i18n =====
  "MarketView.title": "Панель рынка",
  "MarketView.loading": "Загрузка...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Не удалось отобразить вкладку",
  "MarketView.unknownError": "Неизвестная ошибка",

  // ===== Common i18n =====
  "Common.refresh": "Обновить",
  "Common.toggleSeriesVisibility": "Переключить отображение ряда",
  "Common.error": "Ошибка",
  "Common.dataUpdateTime": "Время обновления данных",
  "Common.loading": "Загрузка...",
  "Common.noDataSource": "Нет данных (источник данных не предоставлен)",

  // ===== Common ranges =====
  "Common.to": "до",
  "Common.clear": "Очистить",
  "Common.range.thisMonth": "Этот месяц",
  "Common.range.lastMonth": "Прошлый месяц",
  "Common.range.last2": "Последние 2 месяца",
  "Common.range.last3": "Последние 3 месяца",
  "Common.range.last6": "Последние 6 месяцев",
  "Common.range.thisYear": "Этот год",
  "Common.range.all": "Все",
  "Common.range.custom": "Пользовательский",
  "Common.showFilters": "Показать фильтры",
  "Common.hideFilters": "Скрыть фильтры",
  "Common.search": "Поиск",
  "Common.priority": "Приоритет",
  "Common.owner": "Ответственный",
  "Common.collaborator": "Соисполнитель",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Скачать backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Скачать youtube_stats.json",
  "YouTubeTab.loading": "Загрузка метрик YouTube...",
  "YouTubeTab.errorHint":
    "Если ключ API не настроен, задайте YOUTUBE_API_KEY или GOOGLE_API_KEY в backend/.env и перезапустите бэкенд.",
  "YouTubeTab.header.totalViews":
    "Общее число просмотров (мультиканал, единица: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Общее число подписчиков (мультиканал, единица: 10k)",
  "YouTubeTab.dist.views": "Распределение просмотров (10k)",
  "YouTubeTab.dist.subscribers": "Распределение подписчиков (10k)",
  "YouTubeTab.card.location": "Местоположение:",
  "YouTubeTab.card.registeredAt": "Дата регистрации:",
  "YouTubeTab.card.currentSubscribers": "Текущие подписчики",
  "YouTubeTab.card.currentVideos": "Текущее число видео",
  "YouTubeTab.card.currentTotalViews": "Текущее общее число просмотров",
  "YouTubeTab.card.currentTotalComments": "Текущее общее число комментариев",
  "YouTubeTab.chart.totalSubscribers": "Всего подписчиков",
  "YouTubeTab.chart.totalViews": "Всего просмотров",
  "YouTubeTab.chart.totalComments": "Всего комментариев",
  "YouTubeTab.chart.totalVideos": "Всего видео",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Скачать backend data/x_stats.json",
  "XTab.downloadJson": "Скачать x_stats.json",
  "XTab.loading": "Загрузка метрик X...",
  "XTab.errorHint":
    "Если токен не настроен, задайте X_BEARER_TOKEN или TWITTER_BEARER_TOKEN в backend/.env и перезапустите бэкенд.",
  "XTab.header.totalFollowers":
    "Общее число подписчиков (мультиканал, единица: 10k)",
  "XTab.header.totalEngagement":
    "Общее вовлечение (последние 5 постов: лайки + ретвиты + ответы + цитаты, единица: 10k)",
  "XTab.dist.followers": "Распределение подписчиков (10k)",
  "XTab.dist.engagement":
    "Распределение вовлечения (последние 5 постов: лайки + ретвиты + ответы + цитаты, единица: 10k)",
  "XTab.card.currentFollowers": "Текущие подписчики",
  "XTab.card.currentFollowing": "Текущее число подписок",
  "XTab.card.currentTweets": "Текущее число твитов",
  "XTab.card.recentLikes": "Недавние лайки (последние 5 постов)",
  "XTab.card.recentRetweets": "Недавние ретвиты (последние 5 постов)",
  "XTab.card.recentReplies": "Недавние ответы (последние 5 постов)",
  "XTab.card.recentQuotes":
    "Недавние просмотры (уровень контента, последние 5 постов)",
  "XTab.card.listed": "Число включений в списки (уровень канала)",
  "XTab.smallChart.followers": "Подписчики",
  "XTab.smallChart.tweets": "Твиты",
  "XTab.smallChart.likes": "Недавние лайки",
  "XTab.smallChart.retweets": "Недавние ретвиты",
  "XTab.smallChart.replies": "Недавние ответы",
  "XTab.smallChart.quotes": "Недавние просмотры (уровень контента)",
  "XTab.smallChart.following": "Подписки",
  "XTab.smallChart.listed": "В списках",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Фильтр по месяцу создания:",
  "Analytics.dashboardTitle": "Панель здоровья проекта",
  "Analytics.metric.completionRate": "Завершённость",
  "Analytics.metric.teamVelocity": "Скорость команды",
  "Analytics.metric.blockerRatio": "Доля блокеров",
  "Analytics.metric.workloadBalance": "Баланс нагрузки",
  "Analytics.charts.statusDistribution": "Распределение статусов",
  "Analytics.charts.statusByMonthPercent": "Статус по месяцам (процент)",
  "Analytics.charts.priorityDistribution": "Распределение приоритетов",
  "Analytics.charts.priorityByMonthPercent": "Приоритет по месяцам (процент)",
  "Analytics.charts.functionTypeDistribution": "Распределение по типу функции",
  "Analytics.charts.functionTypeByMonthPercent":
    "Тип функции по месяцам (процент)",
  "Analytics.blocker.ownerPie":
    "Заблокированные задачи · Распределение по ответственным (пончик)",
  "Analytics.blocker.ownerByMonth":
    "Заблокированные задачи · Ответственные по месяцам (процент)",
  "Analytics.bug.ownerPie":
    "Задачи с багами · Распределение по ответственным (пончик)",
  "Analytics.bug.ownerByMonth":
    "Задачи с багами · Ответственные по месяцам (процент)",
  "Analytics.ownerWorkloadDistribution":
    "Распределение рабочей нагрузки команды",
  "Analytics.mode.priority": "Распределение приоритетов",
  "Analytics.mode.status": "Распределение статусов",
  "Analytics.mode.type": "Распределение типов",
  "Analytics.blocker.attentionNeeded":
    "Задачи, требующие немедленного внимания",
  "Analytics.common.status": "Статус",
  "Analytics.common.owner": "Ответственный",
  "Analytics.insights.sectionTitle": "Инсайты проекта и рекомендации",
  "Analytics.insights.efficiency.title":
    "Рекомендации по повышению эффективности",
  "Analytics.insights.efficiency.completionRate":
    "• Текущая завершённость {{rate}}%, следите за блокерами",
  "Analytics.insights.efficiency.avgVelocity":
    "• Средняя скорость команды — {{velocity}} задач/чел.",
  "Analytics.insights.efficiency.workloadBalance":
    "• Баланс нагрузки — {{balance}}%",
  "Analytics.insights.risk.title": "Предупреждения о рисках",
  "Analytics.insights.risk.blockerRatio": "• Доля блокеров {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Доля задач уровня P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• В первую очередь решайте задачи с высоким приоритетом",

  // ===== Kanban i18n =====
  "Kanban.title": "Канбан",
  "Kanban.totalIssues": "Всего {{count}} задач",
  "Kanban.searchPlaceholder":
    "Поиск по заголовку, номеру задачи, ответственному или соисполнителям...",
  "Kanban.status.backlog": "Бэклог",
  "Kanban.status.inProgress": "В работе",
  "Kanban.status.blocked": "Заблокировано / Ожидает подтверждения",
  "Kanban.status.reviewTest": "Ревью / Тест",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Список задач",
  "List.totalIssues": "Всего {{count}} задач",
  "List.viewDetails": "Посмотреть детали",
  "List.openInNewWindow": "Открыть в новом окне",
  "List.empty.title": "Нет задач",
  "List.empty.subtitle": "Создайте первую задачу, чтобы начать рабочий процесс",

  // ===== Assets Register i18n =====
  "Assets.title": "Реестр активов",
  "Assets.totalSets": "Всего комплектов",
  "Assets.table.employee": "Сотрудник",
  "Assets.table.setCount": "Комплекты",
  "Assets.table.model": "Модель",
  "Assets.total": "Итого",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Отслеживание проектных задач",
  "LukkeyIssues.goToDemo": "Перейти на страницу демо",
  "LukkeyIssues.githubProject": "Проект GitHub ↗",
  "LukkeyIssues.githubManageIssues": "Управлять Issues напрямую на GitHub ↗",
  "LukkeyIssues.financeModel": "Финансовая модель",
  "LukkeyIssues.productCoreIssues": "Ключевые проблемы продукта",
  "LukkeyIssues.stats.totalIssues": "📊 Всего задач",
  "LukkeyIssues.stats.completed": "✅ Завершено",
  "LukkeyIssues.stats.inProgress": "🔄 В работе",
  "LukkeyIssues.stats.pending": "⏳ В ожидании",
  "LukkeyIssues.stats.blocked": "🚫 Заблокировано",
  "LukkeyIssues.stats.docs": "📚 Документы",
  "LukkeyIssues.tabs.kanban": "Канбан",
  "LukkeyIssues.tabs.analytics": "Аналитика",
  "LukkeyIssues.tabs.market": "Панель рынка",
  "LukkeyIssues.tabs.assets": "Реестр активов",
  "LukkeyIssues.shareToChatGPT": "Открыть LUKKEY.json в ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Политика конфиденциальности LUKKEY",
  "PrivacyPolicy.intro.p1":
    "В LUKKEY мы считаем, что самая надёжная конфиденциальность — это та, которая всегда полностью находится в руках пользователя.",
  "PrivacyPolicy.intro.p2":
    "Поэтому, независимо от того, используете ли вы аппаратный холодный кошелёк LUKKEY или мобильное приложение LUKKEY (App), мы строго придерживаемся одного непоколебимого принципа:",
  "PrivacyPolicy.intro.p3_strong":
    "Если пользователь явно не разрешил, мы не собираем, не храним и не загружаем никакую информацию о пользователе.",
  "PrivacyPolicy.intro.p3_tail":
    "Все данные, связанные с использованием, хранятся только локально на устройстве пользователя и никогда не передаются в LUKKEY или на какой-либо сервер.",
  "PrivacyPolicy.intro.p4":
    "Настоящая Политика конфиденциальности объясняет, как мы соблюдаем этот принцип.",

  "PrivacyPolicy.s1.title": "1. Область применения",
  "PrivacyPolicy.s1.appliesTo":
    "Настоящая Политика конфиденциальности применяется к:",
  "PrivacyPolicy.s1.item.hardware": "Аппаратный холодный кошелёк LUKKEY",
  "PrivacyPolicy.s1.item.app": "Мобильное приложение LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Оба продукта следуют единому принципу конфиденциальности: «ноль сбора, ноль загрузки, только локальное хранение».",

  "PrivacyPolicy.s2.title": "2. Информация, которую МЫ НЕ собираем",
  "PrivacyPolicy.s2.desc":
    "Для защиты вашей конфиденциальности мы прямо обязуемся не собирать, не загружать и не хранить никакие данные пользователя, включая, помимо прочего:",
  "PrivacyPolicy.s2.li.identity":
    "Идентификационные данные: имя, номер телефона, адрес электронной почты, почтовый адрес",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Чувствительные данные кошелька: приватные ключи, мнемонические фразы, файлы keystore, пароли кошелька",
  "PrivacyPolicy.s2.li.blockchain":
    "Данные блокчейна: адреса кошельков, история транзакций, информация об активах",
  "PrivacyPolicy.s2.li.behavior":
    "Поведенческие данные: логи приложения, записи кликов, поведенческая аналитика",
  "PrivacyPolicy.s2.li.technical":
    "Техническая информация: идентификаторы устройства, геолокация, IP‑адрес",
  "PrivacyPolicy.s2.inShort.title": "Короче говоря:",
  "PrivacyPolicy.s2.inShort.desc":
    "Всё, что вы видите на аппаратном устройстве и в приложении, существует только на вашем устройстве. LUKKEY не имеет к этому доступа.",

  "PrivacyPolicy.s3.title":
    "3. Конфиденциальность и безопасность аппаратного холодного кошелька",
  "PrivacyPolicy.s3.desc":
    "Аппаратный холодный кошелёк LUKKEY обеспечивает полностью офлайн и безопасную среду. Ключевые особенности:",
  "PrivacyPolicy.s3.h1.title": "1. Аппаратная защита военного уровня",
  "PrivacyPolicy.s3.h1.l1": "Secure Element с сертификацией EAL6+",
  "PrivacyPolicy.s3.h1.l2": "Полностью шифрованная связь на уровне аппаратуры",
  "PrivacyPolicy.s3.h2.title": "2. Функции безопасности",
  "PrivacyPolicy.s3.h2.l1": "Аутентификация по отпечатку пальца",
  "PrivacyPolicy.s3.h2.l2": "Режим конфиденциальности",
  "PrivacyPolicy.s3.h2.l3": "Изолированное управление несколькими кошельками",
  "PrivacyPolicy.s3.h3.title": "3. Полная изоляция",
  "PrivacyPolicy.s3.h3.l1": "Отсутствие подключения к Интернету",
  "PrivacyPolicy.s3.h3.l2": "Отсутствие проводного соединения передачи данных",
  "PrivacyPolicy.s3.h4.title": "4. Защита от вскрытия с автоудалением",
  "PrivacyPolicy.s3.h4.desc":
    "Если устройство разобрано, повреждено или подверглось нештатному вторжению, Secure Element автоматически уничтожает чувствительные данные, чтобы приватные ключи не могли быть извлечены.",
  "PrivacyPolicy.s3.h5.title":
    "5. Чувствительные операции выполняются только внутри Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Создание кошелька",
  "PrivacyPolicy.s3.h5.l2": "Импорт кошелька",
  "PrivacyPolicy.s3.h5.l3": "Подписание транзакций",
  "PrivacyPolicy.s3.h5.note":
    "Все чувствительные процессы проходят на 100% внутри Secure Element и никогда не экспонируются на небезопасные чипы или области хранения.",
  "PrivacyPolicy.s3.h6.title":
    "6. Отсутствие хранения чувствительных данных вне Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "В небезопасных областях устройства не хранятся приватные ключи, мнемонические фразы или иные чувствительные сведения.",

  "PrivacyPolicy.s4.title":
    "4. Конфиденциальность и безопасность приложения LUKKEY",
  "PrivacyPolicy.s4.desc":
    "Приложение LUKKEY ориентировано исключительно на отображение информации и отправку уведомлений. Оно не обрабатывает чувствительные данные кошелька.",
  "PrivacyPolicy.s4.n1.title": "1. Чего приложение НЕ делает",
  "PrivacyPolicy.s4.n1.l1": "Не создаёт блокчейн‑кошельки",
  "PrivacyPolicy.s4.n1.l2": "Не импортирует блокчейн‑кошельки",
  "PrivacyPolicy.s4.n1.l3": "Не хранит приватные ключи или мнемонические фразы",
  "PrivacyPolicy.s4.n1.l4": "Не загружает никаких пользовательских данных",
  "PrivacyPolicy.s4.n1.l5":
    "Не проводит поведенческую аналитику, рекламный трекинг или сбор данных",
  "PrivacyPolicy.s4.n2.title": "2. Что приложение ДЕЛАЕТ",
  "PrivacyPolicy.s4.n2.l1":
    "Отображает публично доступную информацию, авторизованную аппаратным устройством",
  "PrivacyPolicy.s4.n2.l2":
    "Предоставляет панель настроек конфиденциальности с объяснением назначения каждой разрешения",
  "PrivacyPolicy.s4.n2.l3":
    "Предоставляет пользователю полный контроль для включения/отключения разрешений в любой момент",
  "PrivacyPolicy.s4.n2.l4": "Предлагает маскирование чувствительной информации",
  "PrivacyPolicy.s4.n2.l5":
    "Отключает скриншоты/запись экрана в отдельных разделах",
  "PrivacyPolicy.s4.n2.l6":
    "Выявляет подозрительные блокчейн‑адреса через локальное сопоставление",
  "PrivacyPolicy.s4.n2.l7":
    "Регулярно обновляет списки опасных URL, контрактов и адресов",
  "PrivacyPolicy.s4.n2.l8":
    "Поток обновлений — строго односторонний: сервер → устройство",
  "PrivacyPolicy.s4.n2.l9":
    "Во время обновлений пользовательские данные никогда не отправляются обратно",
  "PrivacyPolicy.s4.n3.title": "3. Локальное хранение",
  "PrivacyPolicy.s4.n3.p1":
    "Приложение хранит локально только не‑приватные данные, такие как настройки интерфейса, язык и тему. Эти данные:",
  "PrivacyPolicy.s4.n3.l1": "не загружаются",
  "PrivacyPolicy.s4.n3.l2": "не синхронизируются",
  "PrivacyPolicy.s4.n3.l3": "недоступны для LUKKEY",

  "PrivacyPolicy.s5.title": "5. Передача данных и политика серверов",
  "PrivacyPolicy.s5.l1": "Серверы LUKKEY не хранят информацию о пользователях",
  "PrivacyPolicy.s5.l2":
    "Обмен данными между приложением и сервером ограничен обновлениями баз данных и версии",
  "PrivacyPolicy.s5.l3":
    "В ходе обмена не передаётся никакая пользовательская информация",
  "PrivacyPolicy.s5.l4":
    "Даже в случае взлома сервера пользовательские данные не могут быть раскрыты, поскольку мы изначально их не получаем",

  "PrivacyPolicy.s6.title": "6. Прозрачность открытого кода",
  "PrivacyPolicy.s6.l1": "Исходный код приложения LUKKEY открыт",
  "PrivacyPolicy.s6.l2": "Встроенное ПО аппаратного обеспечения LUKKEY открыто",
  "PrivacyPolicy.s6.l3": "Полностью доступно на GitHub для аудита кем угодно",
  "PrivacyPolicy.s6.p": "Прозрачность — часть безопасности.",

  "PrivacyPolicy.s7.title": "7. Полный контроль пользователя",
  "PrivacyPolicy.s7.p":
    "Даже при отсутствии сбора пользовательской информации, пользователи сохраняют полный контроль над своими устройствами:",
  "PrivacyPolicy.s7.l1":
    "Вы можете в любой момент отключить разрешения приложения",
  "PrivacyPolicy.s7.l2":
    "Вы можете удалить приложение, чтобы убрать все локальные данные приложения",
  "PrivacyPolicy.s7.l3":
    "Вы можете сбросить аппаратное устройство, чтобы навсегда стереть приватные ключи и данные кошелька",
  "PrivacyPolicy.s7.p2":
    "LUKKEY не вмешивается и не может вмешаться в эти действия.",

  "PrivacyPolicy.s8.title": "8. Связаться с нами",
  "PrivacyPolicy.s8.p":
    "Если у вас есть вопросы относительно данной Политики конфиденциальности, свяжитесь с нами:",
  "PrivacyPolicy.s8.email": "Эл. почта: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Адрес: Штаб‑квартира LUKKEY, Baarerstrasse 25, 6300 Цуг, Швейцария",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Проверка...",
  "EmailOtp.title":
    "Доступ ограничен: введите имя и e‑mail, чтобы получить код для входа",
  "EmailOtp.nameLabel": "Имя",
  "EmailOtp.namePlaceholder": "Введите имя",
  "EmailOtp.emailLabel": "E‑mail",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Отправить код",
  "EmailOtp.resendCode": "Отправить код повторно",
  "EmailOtp.resendWithCountdown": "Повторная отправка ({{s}}с)",
  "EmailOtp.codeValidityHint": "Код подтверждения действителен около 10 минут",
  "EmailOtp.codeLabel": "Код подтверждения из e‑mail",
  "EmailOtp.codePlaceholder": "Введите полученный код",
  "EmailOtp.signIn": "Войти",
  "EmailOtp.message.codeSent": "Код подтверждения отправлен, проверьте почту",
  "EmailOtp.error.nameRequired": "Введите имя",
  "EmailOtp.error.invalidEmail": "Введите корректный адрес электронной почты",
  "EmailOtp.error.sendFailed":
    "Не удалось отправить код подтверждения. Пожалуйста, попробуйте позже.",
  "EmailOtp.error.codeRequired": "Введите код подтверждения",
  "EmailOtp.error.verificationFailed": "Не удалось подтвердить код",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Напоминание о безопасности: всегда проверяйте ссылки и никогда не делитесь фразой восстановления.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Академия",
  "Academy.hero.subtitle": "Практические руководства по криптобезопасности, self‑custody и использованию холодного кошелька LUKKEY.",
  "Academy.search.placeholder": "Найдите руководства, лучшие практики и ответы на вопросы…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "СТАТЬЯ",
  "Academy.list.title": "Последние руководства",
  "Academy.list.viewAll": "ПОКАЗАТЬ ВСЕ",
  "Academy.list.empty": "Нет результатов. Попробуйте другой запрос.",
  "Academy.image.placeholder": "ИЗОБР.",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Назад в Академию",
  "AcademyArticle.notFound": "Статья не найдена",
  "AcademyArticle.author": "Автор",
  "AcademyArticle.unscheduled": "Нет запланированного времени публикации",
  "home.hero.reserveCtaLabel": "Ранний доступ — 1 $",
  "home.hero.reserveCtaNote": "Полный возврат средств. Без обязательства покупки."
};
export default translation;
